module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadedCount) ? _c('div', {
    staticClass: "homepage"
  }, [_c('div', {
    staticClass: "homepage-left"
  }, [_c('div', {
    staticClass: "homepage-left--top"
  }, [_vm._v("\n      the place in numbers"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "homepage-count",
    attrs: {
      "data-count": _vm.homepage[0].count
    }
  }, [_vm._v("\n        0\n      ")]), _vm._v("      \n      pieces"), _c('br'), _vm._v("\n      (weekly updates)\n    ")]), _vm._v(" "), _c('img', {
    staticClass: "homepage-car",
    attrs: {
      "src": "static/imgs/homepage/homepagecar.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "homepage-left--bottom"
  }, [_c('h4', [_vm._v("Welcome to the E-Type Corner")]), _vm._v(" "), _c('h3', [_vm._v("a magic place")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.homepage[0].body)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "header-nav-button",
    attrs: {
      "to": {
        name: 'the-magic',
        params: {
          filter: 'the-magic'
        }
      }
    }
  }, [_vm._v("Read More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "homepage-right"
  }, [_c('router-link', {
    staticClass: "homepage-right-item",
    style: ({
      'background-image': 'url(' + _vm.api + _vm.homepage[0].manufacturers + ')'
    }),
    attrs: {
      "to": {
        name: 'manufacturers',
        params: {
          filter: 'manufacturers'
        }
      }
    }
  }, [_c('div', {
    staticClass: "homepage-right-item--desc"
  }, [_vm._v("\n        Manufacturers\n      ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "homepage-right-item",
    style: ({
      'background-image': 'url(' + _vm.api + _vm.homepage[0].masterpieces + ')'
    }),
    attrs: {
      "to": {
        name: 'master-pieces',
        params: {
          filter: 'master-pieces'
        }
      }
    }
  }, [_c('div', {
    staticClass: "homepage-right-item--desc"
  }, [_vm._v("\n        Master Pieces\n      ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "homepage-right-item",
    style: ({
      'background-image': 'url(' + _vm.api + _vm.homepage[0].modelhistory + ')'
    }),
    attrs: {
      "to": {
        name: 'model-history',
        params: {
          filter: 'model-history'
        }
      }
    }
  }, [_c('div', {
    staticClass: "homepage-right-item--desc"
  }, [_vm._v("\n        Model History\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "homepage-right-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'intro',
        params: {
          filter: 'intro'
        }
      }
    }
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "muted": "",
      "playsinline": "",
      "loop": "loop"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.api + _vm.homepage[0].video,
      "type": "video/mp4"
    }
  }), _vm._v("\n          Your browser does not support the video tag.\n        ")])])], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ed1ba24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Homepage.vue
// module id = 66
// module chunks = 1